module.exports = __webpack_public_path__ + "images/c021555210815b131ff09250796ecf11.png";